import toCountry from '@/js/common/Domain/Hydrator/toRouter/toCountry';
import resorts from '@/js/common/Domain/Hydrator/toRouter/resorts';
import checkInDateRange from '@/js/common/Domain/Hydrator/toRouter/checkInDateRange';
import nightRange from '@/js/common/Domain/Hydrator/toRouter/nightRange';
import touristGroup from '@/js/common/Domain/Hydrator/toRouter/touristGroup';
import hotelCategories from '@/js/common/Domain/Hydrator/toRouter/hotelCategories';
import operators from '@/js/common/Domain/Hydrator/toRouter/operators';
import meals from '@/js/common/Domain/Hydrator/toRouter/meals';
import hotels from '@/js/common/Domain/Hydrator/toRouter/hotels';
import priceRange from '@/js/common/Domain/Hydrator/toRouter/priceRange';

export default (tourCriteria, otherCriteria) => ({
    ...toCountry(tourCriteria),
    ...resorts(tourCriteria),
    ...checkInDateRange(tourCriteria),
    ...nightRange(tourCriteria),
    ...touristGroup(tourCriteria),
    ...hotelCategories(tourCriteria),
    ...operators(tourCriteria),
    ...meals(tourCriteria),
    ...hotels(tourCriteria),
    ...priceRange(tourCriteria),
    ...otherCriteria,
});